<div class="row">
    <div class="col-sm-12">
        <kendo-expansionpanel [title]="'Accounts'"
                              [subtitle]="'Total: ' + accounts.length"
                              [disabled]="false"
                              [expanded]="true">
            <div class="row" *ngIf="customerStatusList.length > 0 && accountStatusCount.length > 0">
                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-accounts', repType, employeeId, status.customerStatusId]" *ngFor="let status of customerStatusList">
                    <h3>{{status.abbreviation}}</h3>
                    <h2>{{getCustomerStatusCount(status.customerStatusId)}}</h2>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
<div class="row" *ngIf="false">
    <epi-container class="col-sm-12" [header]="'Prospects'">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-accounts', repType, employeeId, 'untouched']">
                    <h3>Untouched Leads</h3>
                    <h2>{{untouchedLeadsCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-accounts', repType, employeeId, 'assigned']">
                    <h3>Assigned Leads</h3>
                    <h2>{{assignedLeadsCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-prospects', repType, employeeId]">
                    <h3>Prospects</h3>
                    <h2>{{prospectCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-prospects', repType, employeeId]">
                    <h3>Rapport Building</h3>
                    <h2>{{rapportBuildingCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-prospects', repType, employeeId]">
                    <h3>Drawing Pain</h3>
                    <h2>{{drawingPainCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-accounts', repType, employeeId, 'late']">
                    <h3>Past Due SW Leads</h3>
                    <h2>{{lateSWLeadCount}}</h2>
                </div>
            </div>
        </div>
    </epi-container>
</div>

<div class="row">
    <div class="col-sm-12">
        <kendo-expansionpanel [title]="'Follow Ups'"
                              [subtitle]="'Total: ' + (pastDueCount + todayCount + comingDueCount)"
                              [disabled]="false"
                              [expanded]="true">
            <div class="row">
                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-follow-ups', repType, employeeId, 'past-due']">
                    <h3>Past Due</h3>
                    <h2>{{pastDueCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-follow-ups', repType, employeeId, 'today']">
                    <h3>Today</h3>
                    <h2>{{todayCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-follow-ups', repType, employeeId, 'coming-due']">
                    <h3>Coming Due This Week</h3>
                    <h2>{{comingDueCount}}</h2>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <kendo-expansionpanel [title]="'Opportunities'"
                              [subtitle]="'Total: ' + (quoteAndBudgetCount + finalistCount + preAwardCount + closingSoonCount)"
                              [disabled]="false"
                              [expanded]="true">
            <div class="row">
                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-opportunities', repType, employeeId]">
                    <h3>Quote &amp; Budget</h3>
                    <h2>{{quoteAndBudgetCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-opportunities', repType, employeeId]">
                    <h3>Finalists</h3>
                    <h2>{{finalistCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-opportunities', repType, employeeId]">
                    <h3>Pre-Awards</h3>
                    <h2>{{preAwardCount}}</h2>
                </div>

                <div class="col-sm-2 dashboard-card" [routerLink]="['/crm-dashboard/crm-opportunities', repType, employeeId]">
                    <h3>Closing Soon</h3>
                    <h2>{{closingSoonCount}}</h2>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
